export const refreshStorage = (state = null, action) => {
    switch (action.type) {
        case 'REFRESH_STORAGE':
            return Math.random();
        default:
            return state
    }
};
